import React, { useEffect } from 'react';
import { get } from 'lodash';
import { Route, Redirect, Navigate, useOutlet } from 'react-router-dom';
import { shallowEqual, useSelector } from 'react-redux';

import InnerSplashScreen from '../InnerSplashScreen';

import { APP_ROUTES } from '../../globals/constants';
// import { verifyToken } from "../../globals/utils/jwtUtils";
import Cookies from 'universal-cookie';

const ProtectedRoute = ({ allowedRoles }) => {
	const cookies = new Cookies();
	const loginData = cookies.get('loginData');
	console.log('loginData', loginData?.role_code);
	const roleCode = loginData?.role_code || '';
	const outlet = useOutlet();

	return (
		<>
			{allowedRoles.find((value) => value === roleCode) ||
			roleCode === 'SUPER_ADMIN' ? (
				[outlet]
			) : (
				<Navigate to="/" />
			)}
		</>
	);
};

export default ProtectedRoute;
